var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("This is test page")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("go back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }